import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";

import ContextComponent from "../../../AppContext";
import AddItemImg from "../../../../assets/img/add-card.png";
import Utils from "../../../Utils";
import TemplateItem from "./TemplateItem";

const TemplatesList = () => {
  let { userData, setCanRedirectToLogin, setLoadingState, setAlert } =
    useContext(ContextComponent);

  let [templates, setTemplates] = useState([]);
  let navigate = useNavigate();

  // useEffect(() => {
  //   if (userData?.cards) {
  //     setUserCards(Utils.getUniqueSetOfArray(userData.cards));
  //   }
  // }, [userData]);

  const navgiatToAddPage = (e) => {
    e.preventDefault();
    navigate(Utils.APP_URLS.ADD_TEMPLATE_PAGE);
  };

  const navgiatToEditPage = (e) => {
    e.preventDefault();
    let templateid = e.currentTarget.attributes.templateid.value;
    //console.log(templateid);
    navigate(
      Utils.APP_URLS.EDIT_TEMPLATE_PAGE.replace(":templateid", templateid)
    );
  };

  const success = (res) => {
    setTemplates(res.data);
    //setUserData(res.data || {});
    setLoadingState({
      applyMask: false,
    });
  };
  const fail = (err) => {
    err?.message?.length && console.log(err);
    setLoadingState({
      applyMask: false,
    });
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  let [loadTemplates, setLoadTemplates] = useState(true);

  useEffect(() => {
    setLoadingState({
      applyMask: true,
      text: "Loading templates",
    });
    Utils.getTemplates().then(success, fail);
  }, [loadTemplates]);

  let [toBeDeleteTemplateId, setToBeDeleteTemplateId] = useState({});

  let [showDeleteTemplateModal, setShowDeleteTemplateModal] = useState(false);

  const initiateDeleteTemplate = async (e) => {
    let templateIndex = parseInt(
      e.currentTarget.attributes["templateindex"].value,
      10
    );
    await setToBeDeleteTemplateId(templates[templateIndex]);
    setShowDeleteTemplateModal(true);
  };

  const handleDeleteTemplateClose = async (e) => {
    //await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteTemplateModal(false);
  };

  const deleteTemplateSuccess = (res) => {
    setLoadingState({
      applyMask: false,
    });
    setLoadTemplates(!loadTemplates);
    setAlert({
      show: true,
      message: "Successfully deleted template!",
    });
  };

  const deleteTemplateFail = (err) => {
    err?.message?.length && console.log(err);
    setLoadingState({
      applyMask: false,
    });
  };

  const handleDeleteTemplate = async (e) => {
    setShowDeleteTemplateModal(false);
    setLoadingState({
      applyMask: true,
      text: "Deleting template",
    });
    let tempId = toBeDeleteTemplateId.id;
    Utils.deleteTemplate(tempId).then(
      deleteTemplateSuccess,
      deleteTemplateFail
    );
  };

  return (
    <>
      <div className="indi-body-cards-wrapper d-flex w-100">
        <div className="indi-body-action-bar w-100">
          <div className="w-50 indi-body-action-bar-title">Templates</div>
        </div>

        <div className="indi-cards-collection-wrapper d-flex">
          <div
            className="d-flex indi-placeholder-add-card indi-card-item-wrapper"
            onClick={navgiatToAddPage}
          >
            <div className="d-flex indi-placeholder-add-card-img">
              <img src={AddItemImg} alt="Add item" />
            </div>
            <div className="d-flex indi-placeholder-add-card-text">
              Add template
            </div>
          </div>
          {templates.map((template, index) => (
            <div className="indi-card-item-wrapper" key={index}>
              <TemplateItem template={template} applyActions={true} />
              <div className="indi-card-template-item-wrapper">
                <div
                  className="indi-item-edit-overlay"
                  onClick={navgiatToEditPage}
                  templateid={template.id}
                ></div>
                <div
                  className="indi-item-delete-overlay"
                  onClick={initiateDeleteTemplate}
                  templateindex={index}
                  templateid={template.id}
                ></div>
              </div>
            </div>
          ))}
        </div>

        <Modal
          centered
          show={showDeleteTemplateModal}
          onHide={handleDeleteTemplateClose}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Are you sure to delete the below template?
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <TemplateItem
                template={toBeDeleteTemplateId}
                applyActions={true}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleDeleteTemplateClose}>
              No
            </Button>
            <Button variant="primary" onClick={handleDeleteTemplate}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default TemplatesList;